<script setup>
import { storeToRefs } from "pinia";
  import { ref, onBeforeMount, computed } from "vue";
  import { useUiStore } from "@/stores/ui";
  import { useAgentsStore } from "@/stores/agents";
import { useCompanyStore } from "@/stores/company";

  const uiStore = useUiStore();
  const agentsStore = useAgentsStore();
  const getModalInfo = computed(()=> uiStore.modalData);
  const getModalAction = computed(()=> uiStore.modalAction);
  const { companyId } = storeToRefs(useCompanyStore());

  let prompts = ref([]);
  const isLoading = ref(true);
  const resetStoreData = () => {
    uiStore.setModalState(false);
    uiStore.setModalData({});
    uiStore.setModalAction(null);
  };

  const action = async (action, data) => {
    //    await resetStoreData();

    await uiStore.setModalAction(action);
    uiStore.setModalState(true);
    await uiStore.setModalData(data);
  };

  onBeforeMount(()=>{

    if(getModalInfo.value && getModalAction.value == 'prompt_history'){

      agentsStore.fetchPromptHistory({companyId: companyId.value, agentId: getModalInfo.value.id}).then((res) => {
        prompts.value = res.data;
        isLoading.value = false;
      }).catch(() => {})
    }

  });

</script>
<template>
  <DModal v-if="getModalAction === 'prompt_history'" :visible="uiStore.modalState" @update:visible="val => { if (!val) resetStoreData() }" :main_classes="[]" :dialog_classes="[]">
    <template #title> Prompt History </template>
    
    <template #body>
      
      <div v-if="isLoading" class="flex justify-center mb-3">
        <div class="spinner-border text-success" role="status">
            <span class="visually-hidden">Loading...</span>
        </div>
      </div>
      <div v-else>
        <div class="files-container flex justify-center">
          <!-- <div class="card-header">
            <h2>Key files</h2>
          </div> -->
          <div v-if="prompts && prompts.length" class="card-body files-grid">
            <div v-for="(prompt, index) in prompts" :key="prompt.id || index" class="files-card">
              <!-- <div class="files-icon">
                <i class="dx-icon-file"></i>
              </div> -->
              <div class="files-content">
                <h3 class="h-80 cursor-pointer" :title="prompt.prompt" v-if="prompt.prompt && prompt.prompt.length > 200">{{ prompt.prompt.substring(0, 200) }} ... </h3>
                <h3 class="h-80 cursor-pointer" v-else>{{ prompt.prompt }}</h3>
                <!-- <p>{{ file.file_type }}</p> -->
              </div>
              <div class="files-actions">
                <span v-if="prompt.current" class="status-badge status-success">Current</span>
                <!-- <span  v-else @click="action('assign_prompt', prompt)" class="status-badge status-testing cursor-pointer">Assign</span> -->
                <button  v-else @click="action('assign_prompt', prompt)" type="button" class="icon-button success" title="Assign Prompt"><i class="bi bi-check-circle-fill"></i></button>
              </div>
            </div>
          </div>
  
          <div>
            <div v-if="!prompts || prompts.length == 0" class="no-data-available">
              <p>No prompts history available.</p>
            </div>
          </div>
  
        </div>
      </div>

    </template>

    <template #footer>
      <div class="w-full">
        <div class="seperator text-center"></div>
        <div class="flex mt-20 justify-center">
          <!-- <button :disabled="!name || isSubmitted" @click="onSubmit" type="button" class="btn btn-primary add-button mr-30">Edit 
            <span v-if="isSubmitted" class="spinner-sm" role="status" aria-hidden="true"></span></button> -->
          <button @click="resetStoreData" type="button" class="btn btn-secondary cancel-button"> Cancel </button>
        </div>
      </div>
    </template>

  </DModal>
</template>
<style scoped lang="scss">

.files-grid {
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  gap: var(--spacing-1);
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }

  .files-card {
    padding: var(--spacing-4);
    border: 1px solid var(--neutral-200);
    border-radius: var(--border-radius-md);
    display: flex;
    gap: var(--spacing-1);
    &:hover {
      border-color: var(--primary-200);
      background-color: var(--primary-50);
      
      .files-icon {
        background-color: var(--primary-500);
        color: white;
      }
    }
  }

  .files-icon {
    width: 40px;
    height: 40px;
    border-radius: var(--border-radius-md);
    background-color: var(--neutral-100);
    color: var(--neutral-600);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    transition: all 0.2s ease;
  }

  .files-content {
    width: 388px;
    h3 {
      margin: 0 0 var(--spacing-1) 0;
      font-size: var(--text-base);
    }
    
    p {
      margin: 0;
      font-size: var(--text-sm);
      color: var(--neutral-600);
    }
  }

  .files-actions{
    margin-left: auto;
    gap: var(--spacing-2);
  }

  .icon-button.success{
    color: #166434;
    &:hover {
      background-color: #166434;
      color: white;
    }
  }  

}
</style>
